import { SchemaPlugin } from './Schema'
import { SnapshotPlugin } from './Snapshot'

import type { RehajePlugin } from '../types'

export * from './Schema'
export * from './Schema.Any'
export * from './Schema.Array'
export * from './Schema.BigInt'
export * from './Schema.Boolean'
export * from './Schema.Date'
export * from './Schema.DateTime'
export * from './Schema.Dynamic'
export * from './Schema.Function'
export * from './Schema.Intersection'
export * from './Schema.Map'
export * from './Schema.Null'
export * from './Schema.Number'
export * from './Schema.Object'
export * from './Schema.Reference'
export * from './Schema.Set'
export * from './Schema.String'
export * from './Schema.TypedSchema'
export * from './Schema.Undefined'
export * from './Schema.Union'
export * from './Schema.Unknown'
export * from './Schema.URLSearchParams'
export * from './Schema.Void'
export * from './Snapshot'

export const InternalPlugins: RehajePlugin[] = [
  new SchemaPlugin(),
  new SnapshotPlugin()
]
